import { createSlice } from "@reduxjs/toolkit";

interface ReportesArbolInterface {
  isGeneraReporte: boolean;
}

const initialState: ReportesArbolInterface = {
  isGeneraReporte: false,
};

export const reportesArbolSilce = createSlice({
  name: "reportesArbol",
  initialState,
  reducers: {
    onChangeReporte: (state, { payload }) => {
      state.isGeneraReporte = payload;
    },
  },
});

//actions creators are generated for each case reducer function
export const {
  onChangeReporte,
} = reportesArbolSilce.actions;
